export default "__VITE_ASSET__3074cf8c__"